class CreateContractReq {
    constructor() {
        this.Id = undefined;
        this.Name = undefined;
        this.Description = undefined;
        this.Category = undefined;
        this.Discount = undefined;
        this.IsWithDiscount = false;
        this.TimeStamp = undefined;
        this.IsSplitSessions = undefined;
        this.SelectedSessionIds = []; 
        this.pagingParams = {
            pageNumber: undefined,
            pageSize: undefined
        };
    }
}

export default CreateContractReq;